import { render, staticRenderFns } from "./RevenueTrends.vue?vue&type=template&id=6a1ae3b4&scoped=true"
import script from "./RevenueTrends.vue?vue&type=script&lang=js"
export * from "./RevenueTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ae3b4",
  null
  
)

export default component.exports